if (!customElements.get('ba-cart-accessories')) {
  customElements.define('ba-cart-accessories', class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick || this.addAccessory.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    async addAccessory(event) {
      const button = event.target.closest('button[data-variant-id]');
      if (!button || !this.contains(button) || this.busy) return;
      const miniCart = this.closest('mini-cart');
      const error = this.querySelector('.ba-cart-accessories__error');
      if (!miniCart || typeof miniCart.getSectionsToRender !== 'function'
        || typeof miniCart.beginMutation !== 'function' || !miniCart.beginMutation(this)) return;

      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('button').forEach((control) => { control.disabled = true; });
      const label = button.querySelector('span');
      const originalLabel = label.textContent;
      label.textContent = this.dataset.adding;
      error.hidden = true;
      const formData = new FormData();
      const sections = [...new Set(miniCart.getSectionsToRender().map((section) => section.section))];
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', '1');
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
      let added = false;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const message = typeof result.description === 'string' ? result.description : this.dataset.error;
          error.textContent = message;
          error.hidden = false;
          return;
        }

        added = true;
        if (sections.every((section) => result.sections?.[section])) {
          miniCart.renderContents(result);
        } else {
          await miniCart.updateSectionContents();
        }
        document.dispatchEvent(new CustomEvent('cart:item-add', {
          detail: { items: [result], context: 'CartAccessory' },
        }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartItemAdd, { source: 'CartAccessory', items: [result] });
        }
        miniCart.querySelector('.mini-cart-header')?.focus();
      } catch {
        await miniCart.updateSectionContents().catch(() => {});
        const visibleError = miniCart.querySelector('#mini-cart-error');
        if (visibleError) visibleError.textContent = added ? this.dataset.refreshError
          : (window.cartStrings?.addUncertain || this.dataset.error);
      } finally {
        miniCart.endMutation(this);
        this.busy = false;
        this.removeAttribute('aria-busy');
        if (this.isConnected) {
          this.querySelectorAll('button').forEach((control) => { control.disabled = false; });
          label.textContent = originalLabel;
        }
      }
    }
  });
}

